import logoImg from '../images/logo-sm.webp'; 

const Logo = ({ LOGO_TEXT }) => {
    return (
      <img
        className="readerum-logo"
        src={logoImg}
        title={LOGO_TEXT}
        alt={LOGO_TEXT}
      />
    );
  };
  
  export default Logo;
  